import { IImageWithObjectKey, IImageWithUrl } from './shared.dto';

export abstract class IAccountContactsDAO {
    public abstract getAccountContacts(accountId: number): Promise<IAccountContactListItemDTO[]>;
    public abstract createAccountContact(accountId: number, params: ICreateAccountContactDTO): Promise<IAccountContactDTO>;
    public abstract updateAccountContact(accountId: number, params: IAccountContactDTO): Promise<IAccountContactDTO>;
}

export interface ICreateAccountContactDTO {
    firstName: string;
    lastName: string;
    title?: string;
    accountOrganizationId: number;
    biography?: string;
    profileImage?: IImageWithObjectKey;
}

export interface IAccountContactDTO extends ICreateAccountContactDTO {
    accountContactId: number;
    profileImageWithUrl?: IImageWithUrl;
}

export interface IAccountContactListItemDTO extends IAccountContactDTO {
    organizationName: string;
}
